import { useCallback } from 'react';

const useCalendarDnDMapping = (
  calendarItems = [],
  expandedItems,
) => {
  /**
   * Returns a map of items that are under a given session break
   */
  const getItemsUnderSessionBreak = useCallback(
    (currentItem) => {
      if (!currentItem || currentItem.type !== 'session_break') return {};

      const currentIndex = calendarItems.findIndex(
        (c) => c.assignedId === currentItem.assignedId,
      );
      if (currentIndex === -1) return {};

      const result = {};
      let reachedNextBreak = false;

      calendarItems.forEach((calItem, i) => {
        if (i <= currentIndex || reachedNextBreak) return;
        if (calItem.type === 'session_break') {
          reachedNextBreak = true;
          return;
        }
        result[calItem.assignedId] = calItem;
      });

      return result;
    },
    [calendarItems],
  );

  /**
   * Determines whether a calendar item should be collapsed under a session break
   */
  const shouldCollapseItemBelongingToSessionBreak = useCallback(
    (currentItem, draggedItem) => {
      // If dragging a session break, items under it should not collapse
      if (
        draggedItem?.type === 'session_break'
        && getItemsUnderSessionBreak(draggedItem)?.[currentItem.assignedId]
      ) {
        return true;
      }

      // Find the last session break above this item
      let sessionBreak = null;
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < calendarItems.length; i++) {
        const calendarItem = calendarItems[i];
        if (calendarItem?.assignedId === currentItem?.assignedId) break;
        if (calendarItem?.type === 'session_break') sessionBreak = calendarItem;
      }

      // Collapse if item belongs to a collapsed session break
      if (
        sessionBreak
        && !sessionBreak.preSave
        && getItemsUnderSessionBreak(sessionBreak)[currentItem.assignedId]
        && !expandedItems[sessionBreak.assignedId]
      ) {
        return true;
      }

      return false;
    },
    [calendarItems, expandedItems, getItemsUnderSessionBreak],
  );

  return {
    getItemsUnderSessionBreak,
    shouldCollapseItemBelongingToSessionBreak,
  };
};

export default useCalendarDnDMapping;
